<div class="oil-gas-router-wrapper">
  <router-outlet></router-outlet>  
</div>
